export default "__VITE_ASSET__aL513cA9__"